import React from 'react';
import PropTypes from 'prop-types';
import gtmParts from 'react-google-tag-manager';


export default function template() {
    const gtm = gtmParts({
        id: this.props.gtmId,
        dataLayerName: this.props.dataLayerName || 'dataLayer',
        additionalEvents: this.props.additionalEvents || {},
        previewVariables: this.props.previewVariables || false,
    });

    return (
        <div>
            <div>{gtm.noScriptAsReact()}</div>
            <div id={this.props.scriptId || 'react-google-tag-manager-gtm'}>
                {gtm.scriptAsReact()}
            </div>
        </div>
    );
}
